import React from 'react'
import {Icon} from '@chakra-ui/react'

const InfoLabelIcon = ({...props}) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="info-icon" {...props}>
            <path
                d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 9.25C20.5091 9.25 20.9219 9.66273 20.9219 10.1719C20.9219 10.681 20.5091 11.0938 20 11.0938V12.25C18.8523 12.25 17.9219 11.3196 17.9219 10.1719C17.9219 9.02417 18.8523 8.09375 20 8.09375V9.25Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 12.25C21.1477 12.25 22.0781 11.3196 22.0781 10.1719C22.0781 9.02417 21.1477 8.09375 20 8.09375V9.25C19.4909 9.25 19.0781 9.66273 19.0781 10.1719C19.0781 10.681 19.4909 11.0938 20 11.0938V12.25Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5 29.5938V14.875H18.5V29.5938H21.5Z"
                fill="white"
            />
        </Icon>
    )
}

export default InfoLabelIcon
